import { createFileRoute, redirect } from '@tanstack/react-router';
import { parseAvcCallbackSearch } from '@vizit/organisms';
import { beforeLoadAuthenticatedValidation } from '../../../../router';

export const Route = createFileRoute('/_authenticated/w/$workspaceSlug/settings/integrations/avc')({
  staticData: {
    pageName: 'Integrations',
  },
  validateSearch: parseAvcCallbackSearch,
  beforeLoad: async ({ context, location, search, params }) => {
    await beforeLoadAuthenticatedValidation(context, location);

    throw redirect({
      to: '/w/$workspaceSlug/settings/integrations',
      params: { workspaceSlug: params.workspaceSlug },
      search: {
        ...(search.avc ? { avc: search.avc } : {}),
        ...(search.id ? { id: search.id } : {}),
        ...(search.reason ? { reason: search.reason } : {}),
      },
    });
  },
});
